import React from 'react';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import DatePicker from 'components/DatePicker';
import usePeriod from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/usePeriod';
import './index.scss';

export default function PeriodSelect() {
  const {
    startDate,
    endDate,
    dateIntervals,
    changePeriodRange,
    changePeriod,
    disabled,
    selectsRange,
  } = usePeriod();

  return (
    <div className="ms-3 agro-maps-period-select">
      <SubtitleRegular>Período de análise</SubtitleRegular>
      {selectsRange && (
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={changePeriodRange}
          includeDateIntervals={dateIntervals}
          placeholderText="Selecionar"
          disabled={disabled}
        />
      )}
      {!selectsRange && (
        <DatePicker
          selected={startDate}
          onChange={changePeriod}
          includeDateIntervals={dateIntervals}
          placeholderText="Selecionar"
          disabled={disabled}
        />
      )}
    </div>
  );
}
